import { render, staticRenderFns } from "./InstallShansuan.vue?vue&type=template&id=fe0a28e2&scoped=true&"
import script from "./InstallShansuan.vue?vue&type=script&lang=ts&"
export * from "./InstallShansuan.vue?vue&type=script&lang=ts&"
import style0 from "./InstallShansuan.vue?vue&type=style&index=0&id=fe0a28e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0a28e2",
  null
  
)

component.options.__file = "InstallShansuan.vue"
export default component.exports